import { useContext } from 'react';
import { NotificationContext } from './NotificationProvider';
import { Context } from './NotificationProps';

const useNotification = (): Context => {
  const context = useContext<Context>(NotificationContext);
  if (!context)
    throw new Error(
      'The "useNotification"-hook can only be used within NotificationProvider!',
    );
  return context;
};

export default useNotification;
